import { render, staticRenderFns } from "./TrainingPlan.vue?vue&type=template&id=792b9d18&scoped=true"
import script from "./TrainingPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingPlan.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TrainingPlan.vue?vue&type=style&index=0&id=792b9d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792b9d18",
  null
  
)

export default component.exports